import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { ROUTER_CONFIG } from '@core/configs';
import { AuthService } from '@core/services/apis';

export const skipLoginGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const accessTokenParam = route.queryParams.accessToken || null;
  const refreshTokenParam = route.queryParams.refreshToken || null;

  try {
    if (accessTokenParam && refreshTokenParam) {
      const userSessionObject = {
        accessToken: accessTokenParam,
        refreshToken: refreshTokenParam,
      };
      authService.loginByToken(userSessionObject);
    } else if (!authService.loggedIn()) {
      return true;
    }
    return true;
  } catch (e) {
    router.navigate([ROUTER_CONFIG.auth.login]);
    return true;
  }
};
